import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {HighlightTypesEnum} from '../../../models/api/highlightBaseModel';
import {InboxModel} from '../../../models/api/inboxModel';
import {ApiLens, LensModel} from '../../../models/api/lensModel';
import {TagModel} from '../../../models/api/tagModel';
import {TeammateModel} from '../../../models/api/teammateModel';
import {postApiAsync} from '../../../services/http/http';
import {ThunkAsyncAction} from '../../appThunk';
import {getCompany} from '../company/companySelectors';
import {updateDataAction} from '../dataGroupsActions';

export interface LensTemplate {
  name: string;
  namespace: string;
  inboxIds: ReadonlyArray<InboxModel['id']>;
  tagIds: ReadonlyArray<TagModel['id']>;
  assigneeTeammateIds: ReadonlyArray<TeammateModel['id']>;
  highlightEmoji: string | undefined;
  highlightColor: PaletteColorsEnum | undefined;
  highlightType: HighlightTypesEnum;
}

// TODO-LENS: consider optimistic updates.
export function createLensAsyncAction(
  template: LensTemplate,
  // TODO-LENS: use or remove the tracking callback.
  trackingCallback?: HandlerOf<LensModel>,
): ThunkAsyncAction<LensModel | undefined> {
  return async (dispatch, getState) => {
    const state = getState();

    const company = getCompany(state);
    const url = `${company.url}/namespaces/${template.namespace}/lenses`;
    const postBody = {
      name: template.name,
      namespace: template.namespace,
      inbox_ids: template.inboxIds,
      tag_ids: template.tagIds,
      assignee_ids: template.assigneeTeammateIds,
      highlight: template.highlightEmoji || template.highlightColor,
    };

    const lens = await postApiAsync(ApiLens, url, postBody);
    dispatch(updateDataAction({lenses: [lens]}));
    return lens;
  };
}
